import React, { useRef, useEffect } from 'react'
import {
  updateAnnotationLayer,
  renderPDFAnnotationLayer,
  useMutationObserver,
} from './PDFAnnotationLayer.utils.js'

export default function PDFAnnotationLayer({ pdfPage, viewport }) {
  const div = useRef(null)

  useEffect(() => {
    renderPDFAnnotationLayer(div, pdfPage, viewport)
  }, [div, pdfPage, viewport])

  // There's not a callback available for when the AnnotationLayer finishes
  // rendering, so we just listen for mutations and fire off our updates
  // once that's done.
  useMutationObserver(div, updateAnnotationLayer(div), {
    childList: true,
    subtree: true,
  })

  return <div className="PDFAnnotationLayer-container" ref={div} />
}
